module.exports = __webpack_public_path__ + "static/media/room-out.0ac3ea1a.svg";